module.exports = __webpack_public_path__ + "img/Abdulla_Avloniy1.3ea38f8d.jpg";